import React from 'react'
import { FormGroup, FormControl } from 'react-bootstrap'

import Label from 'live/components/forms/ui/label'
import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { EntityEditorModal } from '../../../../../generic'
import { IDiagramTopEvent } from '../../RiskDiagramEditor'
import { TOP_EVENT_MAX_CHARS } from '../../../../../utils/constants'

type IProps = {
    handleClose: () => void
    handleDescriptionChange: (e: string) => void
    isOpen: boolean
    item: IDiagramTopEvent
}

export const TopEventModal: React.FC<IProps> = ({ handleClose, isOpen, item, handleDescriptionChange }) => {
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    return (
        <EntityEditorModal
            handleClose={handleClose}
            isOpen={isOpen}
            borderColor="#F1DDBE"
            headerTitle={i18n('TOP EVENT')}
            headerSubtitle={item?.id ? '#' + item.id : ''}
        >
            <FormGroup>
                <Label required className="control-label">
                    {i18n('Name')}
                </Label>
                <FormControl
                    readOnly={!bowtieAdmin}
                    type="text"
                    componentClass="textarea"
                    onChange={e => handleDescriptionChange((e.target as HTMLInputElement).value)}
                    value={item?.name}
                    maxLength={TOP_EVENT_MAX_CHARS}
                    id="diagramEditor-topEventModal-field-name"
                />
            </FormGroup>
        </EntityEditorModal>
    )
}
